<template>
  <div v-if="dadosProposta.dadosCliente" class="wrapperPage pt-8">
    <div class="container flex flex-row items-center justify-between">
      <div class="logo ml-4 w-full">
        <img
          class="img-logo"
          src="../../assets/images/logo/logo-bpseguradora.svg"
        />
      </div>
      <div class="w-full flex flex-col p-1 text-sm">
        <h3 class="flex justify-center">Cotação de Seguro</h3>
      </div>
      <div class="w-full flex flex-col p-1 text-sm items-end">
        <img
          v-if="dadosProposta.regionalLogo"
          class="img-logo"
          :src="dadosProposta.regionalLogo"
        />
        <h3 v-if="!dadosProposta.regionalLogo" class="text-right">
          {{ dadosProposta.regional }}
        </h3>
      </div>
    </div>

    <div class="container justify-center">
      <!-- DADOS COTAÇÃO -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="3">DADOS DA COTAÇÃO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>N° Cotação:</b> {{ dadosProposta.idProposta }}
            </td>
            <td class="pl-3">
              <b>Data da Cotação:</b> {{ dadosProposta.dataEmissao }}
            </td>
            <td class="pl-3">
              <b>Validade:</b> {{ dadosProposta.dataVencimentoCotacao }}
            </td>
          </tr>
          <tr>
            <td class="pl-3"><b>Seguradora: </b>BP SEGURADORA</td>
            <td class="pl-3"><b>CNPJ: </b>50.180.527/0001-13</td>
            <td class="pl-3"><b>SUSEP: </b>{{ SUSEP_CODE.BP_SEGURADORA }}</td>
          </tr>
          <tr>
            <td class="pl-3"><b>Ramo: </b>05.31 - Automóvel</td>
            <td class="pl-3">
              <b>É uma renovação?</b>
              {{
                getInsuranceCompanyLabel(
                  dadosCotacao.addition_information.insurance_company_code,
                  insuranceCompanies,
                )
              }}
            </td>
            <td
              class="pl-3"
              v-if="
                hasInsuranceCompany(
                  dadosCotacao.addition_information.insurance_company_code,
                  insuranceCompanies,
                )
              "
            >
              <b>Classe de bônus:</b>
              {{ dadosCotacao.addition_information.bonus }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.DATA"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.DATA"
        ></div>
      </vx-card>

      <!-- DADOS DA CORRETORA -->
      <vx-card class="mt-2 card-impressao pagebreak-inside-avoid">
        <table class="table card-impressao table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">CORRETORA</th>
          </tr>
          <tr>
            <td class="pl-3" colspan="2">
              <b>Corretora:</b>
              {{
                dadosCotacao.broker.corporateReason || dadosProposta.regional
              }}
            </td>
            <td class="pl-3" colspan="2">
              <b>CNPJ/CPF:</b> {{ dadosProposta.regionalCnpj }}
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="2">
              <b>SUSEP:</b> {{ dadosProposta.regionalSusep }}
            </td>
            <td class="pl-3" colspan="1">
              <b>Cidade:</b> {{ dadosProposta.regionalCidade }}
            </td>
            <td class="pl-3" colspan="1">
              <b>UF:</b> {{ dadosProposta.regionalEstado }}
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="2">
              <b>Telefone:</b> {{ dadosCotacao.broker.phoneNumber }}
            </td>
            <td class="pl-3" colspan="1">
              <b>Email:</b> {{ dadosCotacao.broker.email }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.BROKER_DATA"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.BROKER_DATA"
        ></div>
      </vx-card>

      <!-- DADOS PESSOAIS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="3">SEGURADO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>{{ getLabelSegurado(dadosProposta.dadosCliente.cpf) }}</b
              >:
              {{
                dadosProposta.dadosCliente.associado
                  ? dadosProposta.dadosCliente.associado
                  : ''
              }}
            </td>
            <td
              class="pl-3"
              v-if="
                isPessoaFisica(dadosProposta.dadosCliente.cpf) &&
                !dadosProposta.dadosCliente.associadoNomeSocial
              "
            >
              <b>Nome Social:</b>
            </td>
            <td class="pl-3">
              <b>{{
                isPessoaFisica(dadosProposta.dadosCliente.cpf) ? 'CPF' : 'CNPJ'
              }}</b
              >:
              {{
                dadosProposta.dadosCliente.cpf
                  ? dadosProposta.dadosCliente.cpf
                  : ''
              }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.INSURED"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.INSURED"
        ></div>
      </vx-card>

      <!-- DADOS CONDUTOR -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="3">CONDUTOR PRINCIPAL</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Condutor é o segurado?</b>
              {{
                dadosCotacao.prospect.tax_id === dadosCotacao.driver.tax_id
                  ? 'Sim'
                  : 'Não'
              }}
            </td>
            <td class="pl-3" colspan="1">
              <b>{{
                dadosCotacao.driver.social_name ? 'Nome Social' : 'Nome'
              }}</b
              >:
              {{ dadosCotacao.driver.name ? dadosCotacao.driver.name : '' }}
            </td>
            <td v-if="!dadosCotacao.driver.social_name" class="pl-3">
              <b>Nome Social:</b>
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>CPF</b>:
              {{ dadosCotacao.driver.tax_id ? dadosCotacao.driver.tax_id : '' }}
            </td>
            <td class="pl-3">
              <b>Data de Nascimento</b>:
              {{
                dadosCotacao.driver.birthdate
                  ? functions.formataDataMomentJS(dadosCotacao.driver.birthdate)
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Sexo de Nascimento</b>:
              {{ dadosCotacao.driver.gender ? dadosCotacao.driver.gender : '' }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.MAIN_DRIVER"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.MAIN_DRIVER"
        ></div>
      </vx-card>

      <!-- ENDEREÇO -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="12">ENDEREÇO DE PERNOITE</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>CEP</b>:
              {{
                dadosCotacao.overnight_address.zip_code
                  ? dadosCotacao.overnight_address.zip_code
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Endereço</b>:
              {{
                dadosCotacao.overnight_address.street
                  ? dadosCotacao.overnight_address.street
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Número</b>:
              {{
                dadosCotacao.overnight_address.number
                  ? dadosCotacao.overnight_address.number
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Complemento</b>:
              {{
                dadosCotacao.overnight_address.complement
                  ? dadosCotacao.overnight_address.complement
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Bairro</b>:
              {{
                dadosCotacao.overnight_address.neighborhood
                  ? dadosCotacao.overnight_address.neighborhood
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Cidade</b>:
              {{
                dadosCotacao.overnight_address.city
                  ? dadosCotacao.overnight_address.city
                  : ''
              }}
            </td>
            <td class="pl-3" colspan="2">
              <b>Estado</b>:
              {{
                dadosCotacao.overnight_address.state
                  ? dadosCotacao.overnight_address.state
                  : ''
              }}
            </td>
            <td colspan="4"></td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.OVERNIGHT_ADDRESS"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.OVERNIGHT_ADDRESS"
        ></div>
      </vx-card>

      <!-- DADOS VEÍCULO -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table">
          <tr class="title p-1 w-full">
            <th :colspan="getColspan">DADOS DO VEÍCULO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Veículo 0 km?</b>
              {{ dadosCotacao.vehicle.is_brand_new ? 'Sim' : 'Não' }}
            </td>
            <td class="pl-3">
              <b>Chassi</b>: {{ dadosCotacao.vehicle.chassis }}
            </td>
            <td
              class="pl-3"
              v-if="
                dadosCotacao.vehicle.is_brand_new &&
                dadosCotacao.vehicle.invoice_number
              "
            >
              <b>Número da NF</b>: {{ dadosCotacao.vehicle.invoice_number }}
            </td>
            <td
              class="pl-3"
              v-if="
                dadosCotacao.vehicle.is_brand_new &&
                dadosCotacao.vehicle.invoice_number
              "
            >
              <b>Data da NF</b>: {{ dadosCotacao.vehicle.invoice_date }}
            </td>
            <td class="pl-3"><b>Placa</b>: {{ dadosCotacao.vehicle.plate }}</td>
          </tr>
          <tr>
            <td class="pl-3"><b>Marca</b>: {{ dadosCotacao.vehicle.brand }}</td>
            <td class="pl-3">
              <b>Modelo</b>: {{ dadosCotacao.vehicle.model }}
            </td>
            <td class="pl-3">
              <b>Ano Modelo</b>:
              {{
                dadosCotacao.vehicle.year_model === 32000
                  ? '0Km'
                  : dadosCotacao.vehicle.year_model
              }}
            </td>
            <td class="pl-3">
              <b>Código da Fipe</b>: {{ dadosCotacao.vehicle.fipe_code }}
            </td>
            <td
              class="pl-3"
              v-if="
                dadosCotacao.vehicle.is_brand_new && dadosCotacao.vehicle.plate
              "
            ></td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.VEHICLE"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.VEHICLE"
        ></div>
      </vx-card>

      <!-- AGRAVOS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="2">QUESTIONÁRIO DE AVALIAÇÃO DE RISCO</th>
          </tr>
          <tr v-for="(item, index) in dadosProposta.agravos" :key="index">
            <td class="pl-3">{{ getAgravoPergunta(item) }}</td>
            <td class="pl-3">{{ getAgravoResposta(item) }}</td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.RISK_QUESTIONNAIRE"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.RISK_QUESTIONNAIRE"
        ></div>
      </vx-card>

      <!-- PRODUTOS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="3">COBERTURAS</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Cobertura</b>
            </td>
            <td class="pl-3">
              <b>Limite Máximo Indenização</b>
            </td>
            <td class="pl-3">
              <b>Prêmio Líquido</b>
            </td>
          </tr>
          <tr v-for="(item, index) in selectedCoverage" :key="index">
            <td class="pl-3">
              {{ item.productName }}
            </td>
            <td class="pl-3">
              {{ getFormattedItemLmi(item) }}
            </td>
            <td class="pl-3">
              {{ functions.formataReal(item.values.originalValue) }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.COVERAGES"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.COVERAGES"
        ></div>
      </vx-card>

      <!-- SERVIÇOS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="1">SERVIÇOS</th>
          </tr>
          <tr v-for="(item, index) in selectedServices" :key="index">
            <td class="pl-3">
              <b>Serviço</b>:
              {{ getFormattedItemName(item) }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.SERVICES"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.SERVICES"
        ></div>
      </vx-card>

      <!-- FRANQUIA DE VIDROS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">FRANQUIA</th>
          </tr>
          <tr>
            <td class="pl-3">{{ comprehensiveLabel }}</td>
            <td class="pl-3">
              <b>Franquia</b>:
              {{
                functions.formataReal(
                  getComprehensiveFranchise(selectedCoverage),
                )
              }}
            </td>
            <td v-if="selectedGlass.length > 0" class="pl-3">
              {{ formatNameGlass(selectedGlass[0].name) }}
            </td>
            <td v-if="selectedGlass.length > 0" class="pl-3">
              <b>Franquia</b>:
              {{ functions.formataReal(selectedGlass[0].value) }}
            </td>
          </tr>
          <tr v-for="(item, index) in selectedGlassOdd" :key="index">
            <td class="pl-3">
              {{ formatNameGlass(item.name) }}
            </td>
            <td class="pl-3">
              <b>Franquia</b>:
              {{ functions.formataReal(item.value) }}
            </td>
            <td v-if="selectedGlassEven[index + 1]" class="pl-3">
              {{ formatNameGlass(selectedGlassEven[index + 1].name) }}
            </td>
            <td v-if="selectedGlassEven[index + 1]" class="pl-3">
              <b>Franquia</b>:
              {{ functions.formataReal(selectedGlassEven[index + 1].value) }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.FRANCHISE"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.FRANCHISE"
        ></div>
      </vx-card>

      <!-- PAGAMENTOS -->
      <vx-card class="mt-2 pagebreak-inside-avoid">
        <table class="table table-bordered w-full table-pt">
          <tr class="title p-1 w-full">
            <th colspan="12">PAGAMENTO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Prêmio Líquido</b>:
              {{ functions.formataReal(dadosCotacao.prize.tariff_prize) }}
            </td>
            <td class="pl-3">
              <b>IOF</b>:
              {{ functions.formataReal(dadosCotacao.prize.iof_value) }}
            </td>
            <td class="pl-3">
              <b>Prêmio Total</b>:
              {{ functions.formataReal(dadosCotacao.prize.prize) }}
            </td>
          </tr>
        </table>
        <table
          v-for="(item, index) in dadosProposta.empresaTipoPagamento"
          :key="index"
          class="table table-bordered table-striped-col"
        >
          <tr class="title p-1 w-full">
            <th :colspan="item.qtdParcelas" class="uppercase">
              {{
                getNomePagamento(
                  item.TipoPagamento_domTipoPagamento.nomePagamento,
                )
              }}
            </th>
          </tr>
          <tr>
            <td
              v-for="(parcela, index) in item.installments"
              :key="index"
              class="font-small"
            >
              <b>{{ `${parcela.installment}x` }}</b>
            </td>
          </tr>
          <tr>
            <td
              v-for="(parcela, index) in item.installments"
              :key="index"
              class="font-small"
            >
              {{ calcularValorParcela(item, parcela) }}
            </td>
          </tr>
          <tr>
            <td
              v-for="(parcela, index) in item.installments"
              :key="index"
              class="font-xsmall"
            >
              {{ parcela.fractionation !== 0 ? 'com juros' : 'sem juros' }}
            </td>
          </tr>
        </table>
        <div
          v-if="customSectionsMsgs.PAYMENT"
          style="text-align: justify"
          class="pl-3 pt-3"
          v-html="customSectionsMsgs.PAYMENT"
        ></div>
      </vx-card>

      <!-- DISPOSIÇÕES GERAIS -->
      <vx-card class="mt-2">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="1">DISPOSIÇÕES GERAIS</th>
          </tr>
          <tr>
            <td class="pl-2 pr-2" style="text-align: justify">
              <div
                style="text-align: justify"
                class="pl-3 pt-3"
                v-html="customSectionsMsgs.GENERAL_PROVISIONS"
              ></div>
            </td>
          </tr>
          <div class="mt-5 flex justify-end">
            <vs-button
              color="success"
              type="gradient"
              class="w-2/6 btn-print"
              @click="imprimePDF()"
            >
              Exportar PDF
            </vs-button>
          </div>
        </table>
      </vx-card>
    </div>
  </div>
</template>

<script>
const { TIPO_APOLICE } = require('../../../common/constant/tipo_apolice.js');
import VxCard from '../../components/vx-card/VxCard.vue';
import locale from '../../locale.js';
import { calcularFranquia } from '../../services/cotacao.js';
import contractApi from '../../services/contract.api.js';
import {
  PDF_DOCUMENT_TYPES,
  PRODUCTS_GROUPING,
  TRANSLATE_GLASS_FRANCHISES,
  VEHICLE_TYPE_CODE_LABEL,
} from '../../utils/constants.js';
import functions from '../../utils/functions.js';

import { SUSEP_CODE } from '../../constants/susep.code.enum.js';
import {
  getAllFranchises,
  getComprehensiveFranchise,
  getCustomSectionMsgs,
  getFormattedItemLmi,
  getFormattedItemName,
  getInsuranceCompanyLabel,
  getSelectedGlassServices,
  hasInsuranceCompany,
  somaValorTotalValoresAvista,
} from '../../services/contract.js';
import notify from '../../utils/notify.js';

export default {
  data() {
    return {
      SUSEP_CODE,
      comprehensiveLabel: 'Casco compreensivo',
      PRODUCTS_GROUPING,
      hasInsuranceCompany,
      getInsuranceCompanyLabel,
      somaValorTotalValoresAvista,
      getFormattedItemLmi,
      getFormattedItemName,
      getComprehensiveFranchise,
      customSectionsMsgs: {},
      TIPO_APOLICE,
      dadosProposta: {},
      dadosCotacao: {},
      textoContrato: '',
      functions,
      controller: 'auto',
      action: 'quotations',
      insuranceCompanies: [],
    };
  },
  computed: {
    getColspan() {
      return this.dadosCotacao.vehicle.is_brand_new ? 5 : 4;
    },
    selectedCoverage() {
      return functions.getContractedProductsWithDetails(
        this.dadosCotacao.coverage_contracted,
        this.dadosCotacao.all_coverages,
        false,
      );
    },
    selectedServices() {
      return functions.getContractedProductsWithDetails(
        this.dadosCotacao.coverage_contracted,
        this.dadosCotacao.all_coverages,
        true,
      );
    },
    selectedGlass() {
      const glassServices = this.selectGlassServices();
      return getAllFranchises(glassServices);
    },
    selectedGlassOdd() {
      return this.selectedGlass.filter((_, index) => index % 2 !== 0);
    },
    selectedGlassEven() {
      return this.selectedGlass.filter((_, index) => index % 2 === 0);
    },
  },
  methods: {
    selectGlassServices() {
      return getSelectedGlassServices(
        this.dadosCotacao.coverage_contracted,
        this.dadosCotacao.all_coverages.details,
      );
    },
    formatNameGlass(name) {
      return TRANSLATE_GLASS_FRANCHISES[name] || name;
    },
    imprimePDF() {
      window.print();
    },
    getAgravoPergunta(item) {
      const [pergunta] = Object.keys(item);
      return pergunta;
    },
    getAgravoResposta(item) {
      const [resposta] = Object.values(item);
      return resposta.resposta;
    },
    buscaDados() {
      if (this.$route.query.interno) {
        this.isInterno = true;
      } else {
        this.isInterno = false;
      }
      this.$vs.loading();

      contractApi
        .getAutoQuotationContract(this.$route.params.chave)
        .then((res) => {
          this.dadosCotacao = res.auto;
          this.dadosProposta = calcularFranquia(res.proposal);

          let textoContrato = res.proposal.termos.find(
            (x) => x.tipoContrato == 'Termo de Ativação',
          );
          if (this.dadosProposta.tipoProposta == 'Reativação') {
            textoContrato = res.proposal.termos.find(
              (x) => x.tipoContrato == 'Termo de Reativação',
            );
          }
          this.textoContrato = textoContrato && textoContrato.modeloContrato;

          this.customSectionsMsgs = getCustomSectionMsgs(
            res.proposal.termos,
            PDF_DOCUMENT_TYPES.QUOTATION,
          );
          this.insuranceCompanies = (res.congeners || []).map((congener) => ({
            id: congener.susep_code,
            label: congener.name,
          }));
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          notify.notifyFail(
            this.$vs,
            'Ocorreu um erro, por favor tente novamente',
          );
        });
    },
    isPessoaFisica(cpf) {
      return cpf.length <= 14 ? true : false;
    },
    getLabelSegurado(cpf) {
      if (this.isPessoaFisica(cpf)) {
        return this.dadosProposta.dadosCliente.associadoNomeSocial
          ? 'Nome Social'
          : 'Nome';
      }
      return 'Razão Social';
    },
    calcularValorParcela(item, parcela) {
      const valorBase = this.dadosCotacao.prize.prize;
      const juros = (parcela.fractionation || 0) / 100;

      if (juros == 0) {
        return functions.formataReal(valorBase / parcela.installment);
      }

      const valorParcela =
        (valorBase * (Math.pow(1 + juros, parcela.installment) * juros)) /
        (Math.pow(1 + juros, parcela.installment) - 1);

      return functions.formataReal(valorParcela);
    },
    calcularValorJuros(item, parcela) {
      const valorBase = this.dadosCotacao.prize.prize;
      const valorParcela = valorBase / parcela;
      const juros = (item.jurosMensal || 0) / 100;
      const valorParcelaComJuros = valorParcela * Math.pow(1 + juros, parcela);

      return functions.formataReal(valorParcelaComJuros - valorParcela);
    },
    getNomePagamento(nomePagamento) {
      if (nomePagamento.toLowerCase() === 'boleto') {
        return 'Boleto Bancário';
      }
      return nomePagamento;
    },
    getLabelVehicleTypeCode() {
      return (
        VEHICLE_TYPE_CODE_LABEL[this.dadosCotacao.vehicle.type_id] ||
        this.dadosCotacao.vehicle.type_id
      );
    },
  },
  async created() {
    await this.buscaDados();
    this.$validator.localize('ptBr', locale);
  },
  components: { VxCard },
};
</script>

<style>
@import url('https://fonts.cdnfonts.com/css/gotham');

.table-striped-col td:nth-child(2n) {
  background-color: #edf4fb;
}

.table-striped-col td:nth-child(2n + 1) {
  background-color: #ffffff;
}

.cabecalho-impressao {
  display: none;
}

.wrapperPage {
  font-family: 'regular', 'Gotham', sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
}

.img-logo {
  width: 200px;
  height: 100px;
}

table {
  width: 100%;
  /* gap: 20px; */
  table-layout: auto;
}

tr:nth-child(odd) {
  background-color: #edf4fb;
}

.title {
  background-color: #2b50bb !important;
  color: white;
}

.font-small {
  font-size: 0.8rem;
}

.font-xsmall {
  font-size: 0.7rem;
}

.uppercase {
  text-transform: uppercase;
}

.listItemsProtecoes {
  color: rgb(59, 59, 59);
  font-size: 0.9rem;
  font-weight: 600;
}

.textoRodape {
  font-family: 'Roboto', sans-serif;
  color: #3e3e3e;
  font-size: 0.75rem;
  font-weight: 400;
  text-align: justify;
  text-justify: inter-word;
}

.container-assinaturas {
  height: 200px;
  display: flex;
  align-items: flex-end;
  justify-content: space-around;
}

.A3 .sheet {
  width: 297mm;
  height: 419mm;
}
.A3.landscape .sheet {
  width: 420mm;
  height: 297mm;
}
.A4 .sheet {
  width: 100%;
  height: 297mm;
}
.A4.landscape .sheet {
  width: 297mm;
  height: 210mm;
}
.A5 .sheet {
  width: 148mm;
  height: 210mm;
}
.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm;
}
.sheet.padding-15mm {
  padding: 15mm;
}
.sheet.padding-20mm {
  padding: 20mm;
}
.sheet.padding-25mm {
  padding: 25mm;
}
/** For screen preview **/
@media screen {
  body {
    background: #e0e0e0;
    display: flex;
    justify-content: center;
  }
  .sheet,
  .quebraPagina {
    background: white;
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
    margin-top: 1em;
    margin-bottom: 1em;
  }
}

@page {
  size: A4;
  margin: 0;
}

/* Defina o conteúdo do rodapé no formato "Página X de Y" no centro do rodapé */
@page {
  @bottom-center {
    content: 'Página ' counter(page) ' de ' counter(pages);
  }
}

/** Fix for Chrome issue #273306 **/
@media print {
  .A3.landscape {
    width: 420mm;
  }
  .A3,
  .A4.landscape {
    width: 297mm;
  }
  .A4,
  .A5.landscape {
    width: 210mm;
  }
  .A5 {
    width: 148mm;
  }
}
@media screen {
  .printer {
    display: none;
  }
}
@media print {
  .non-printer {
    display: none;
  }
  .vue-back-to-top {
    display: none !important;
  }
  .pdf {
    width: auto;
    height: 200mm;
  }
  .folha {
    height: 297mm;
    padding: 0 0 0 0;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .router-header,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
  .pagebreak-before {
    break-before: always;
    page-break-before: always;
  }
  .pagebreak-after {
    break-after: always;
    page-break-after: always;
  }
  .pagebreak-inside-avoid {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .vx-card__body {
    padding: 0 !important;
    margin: 0 !important;
  }
  .img-logo {
    width: 100px;
    height: 50px;
  }
  .wrapperPage {
    padding-top: 1em !important;
    margin: 0;
  }
  .cabecalho-impressao {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }
  @page {
    size: A4;
    margin: 0;
    padding: 0;
  }
  .container {
    padding: 8px;
    margin: 0;
    width: 100%;
    max-width: 100%;
  }
  .table-pt {
    padding-top: 8px !important;
  }
}
</style>
